module.exports = __webpack_public_path__ + "assets/grass-curve-bottom.7993408d.svg";